import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHSixtySixPreLogin',
    name: 'IFPageOneHSixtySixPreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtySix/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHSixtySixLogin' ||
        from.path === '/IFPageOneHSixtySixLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHSixtySixLogin',
    name: 'pageOneHSixtySixLogin',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtySix/login.vue'),
  },
  {
    path: '/IFPageOneHSixtySixLoginLoading',
    name: 'pageOneHSixtySixLoginLoading',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtySix/loginLoading.vue'),
  },
  {
    path: '/IFPageOneHSixtySixLeaveInfo',
    name: 'pageOneHSixtySixLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtySix/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHSixtySixResult',
    name: 'pageOneHSixtySixResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHSixtySix/result.vue'),
  },
  {
    path: '/IFPageOneHSixtySixLoading',
    name: 'pageOneHSixtySixLoading',
    component: () => import('@/pages/pageListAll/pageOneHSixtySix/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageOneHSixtySixLoginSecond',
    name: 'pageOneHSixtySixLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHSixtySix/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHSixtySixOnline',
    name: 'pageOneHSixtySixOnline',
    component: () => import('@/pages/pageListAll/pageOneHSixtySix/online.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageOneHSixtySixLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageOneHSixtySixGuide',
    name: 'pageOneHSixtySixLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneHSixtySix/guide.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  /*{
    path: '/IFPageOneHSixtySixCar',
    name: 'pageOneHSixtySixCar',
    component: () => import('@/pages/pageListAll/pageOneHSixtySix/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageOneHSixtySixCarDetails',
    name: 'pageOneHSixtySixCarDetails',
    component: () => import('@/pages/pageListAll/pageOneHSixtySix/carDetails.vue'),
    meta: {
      title: '申请结果',
    },
  },*/
  {
    path: '/IFPageOneHSixtySixBlank',
    name: 'pageOneHSixtySixBlank',
    component: () => import('@/pages/pageListAll/pageOneHSixtySix/blank.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHSixtySixOnlineTab',
    name: 'pageOneHSixtySixOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneHSixtySix/onlineTab.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHSixtySixOnlineAd',
    name: 'pageOneHSixtySixOnlineAd',
    component: () => import('@/pages/pageListAll/pageOneHSixtySix/onlineAd.vue'),
    meta: {
      title: projectName,
    },
  },
];
